import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Template from './Details';

const TemplatePicker = (props) => {
  const { pageContentResource } = usePageContentContext();

  return pickFunction(pageContentResource, {
    [fr.relationships.default.name]: () => {
      return (
        <Template {...props} />
      );
    },
  });
};

export default TemplatePicker;
